module.exports = __webpack_public_path__ + "static/media/snowy-6.34f01c18.svg";